import type { CommonSlice } from '../bs/common'

/**
 * English for the shared strings.
 *
 * Complete, not partial — see en/index.ts. The plain factory register: "No
 * connection to the server", not "A network error has occurred".
 */
export const common: CommonSlice = {
  'error.offline': 'No connection to the server. Check your internet.',
  'error.forbidden': 'You are not allowed to do that.',
  'error.notFound': 'That could not be found.',
  'error.sessionExpired': 'Your session has expired. Please sign in again.',
  'error.tooManyRequests': 'Too many requests. Wait a moment.',
  'error.server': 'Server error. Please try again.',
  'error.generic': 'Something went wrong.',
  'error.boundary.title': 'This page could not be shown',
  'error.boundary.body': 'The error has been recorded. The rest of the application still works — you can go back and carry on.',
  'error.staleBuild.title': 'A new version was released',
  'error.staleBuild.body': 'This tab has been open since before the release, so part of the application is no longer available. Reload the page — nothing has been lost.',
  'error.staleBuild.reload': 'Reload the page',
  'error.supportSessionExpired': 'The support session has expired.',

  'action.save': 'Save',
  'action.cancel': 'Cancel',
  'action.close': 'Close',
  'action.back': 'Back',
  'action.delete': 'Delete',
  'action.edit': 'Edit',
  'action.confirm': 'Confirm',
  'action.retry': 'Try again',
  'action.search': 'Search',
  'action.filter': 'Filter',
  'action.clear': 'Clear',
  'action.more': 'More',
  'action.showOptions': 'Show suggestions',

  'state.loading': 'Loading…',
  'state.saving': 'Saving…',
  'state.empty': 'Nothing to show.',
  'state.saved': 'Saved.',
  'state.noMatches': 'No matches. What you typed is kept.',

  /*
   * English needs two forms where the other three need three, and the split
   * falls in a different place — so this is a template per language rather
   * than a shared one with a plural helper bolted on.
   */
  'unit.days': '{count} days',

  'time.justNow': 'just now',
  'time.minutesAgo': '{count} min ago',
  'time.hoursAgo': '{count} h ago',
  'time.yesterday': 'yesterday',
  'time.daysAgo.one': '{count} day ago',
  'time.daysAgo.few': '{count} days ago',
  'time.daysAgo.many': '{count} days ago',
  'unit.minutesShort': '{count} min',
  'unit.hoursShort': '{count} h',
  'unit.daysLong.one': '{count} day',
  'unit.daysLong.few': '{count} days',
  'unit.daysLong.many': '{count} days',
  // The unit is a parameter, not part of the sentence: it belongs to the
  // company rather than to the language. See lib/currency.ts.
  'unit.money': '{amount} {currency}',
  'unit.hours': '{count} hours',

  'version.label': 'Version',
  'update.consequence':
    'Reload when you have finished what you are doing — unsaved entries on this screen are lost, and queued reports stay.',

  'help.explain': 'What this means',
  'help.readMore': 'More in the guide →',

  'export.started': 'Download started.',
  'export.failed': 'The export failed.',

  'queue.sent.one': 'Your saved report has been sent.',
  'queue.sent.few': '{count} saved reports have been sent.',
  'queue.sent.many': '{count} saved reports have been sent.',
  'queue.failed.one': 'One report was not accepted. Open the queue.',
  'queue.failed.few': '{count} reports were not accepted. Open the queue.',
  'queue.failed.many': '{count} reports were not accepted. Open the queue.',
  'queue.nothing': 'There is nothing to send.',
  'queue.discarded': 'The report has been removed from the queue.',

}
